export function setMenu(state,bool) {
    state.principal = bool;
}

